import Notification from '@/components/Notification/Notification';

export default Notification;
